export default __webpack_public_path__ + "753e8b9.png";